import { NavLink, Outlet } from "react-router-dom"

export default function QuizLayout() {
  return (
    <div className="container help-layout " dir="rtl">

      <h2 className="layout-title">تعليمات الموقع</h2>
      <ul className="layout-list">
        <li>
          <h4>ما هي الطريقة الخاصة للدراسة في الموقع؟</h4>
          <p>للتركيز على موضوع دراسة نظرية واحد قصير ومركّز في وقت يؤدي فيه الجمع بين الدراسة والممارسة إلى تحسين
ويحقق الذاكرة نجاحًا سريعًا من الناحية النظرية </p>
        </li>
        <li>
          <h4>كيف تتعلم؟</h4>
          <p>تنقسم موضوعات الدراسة إلى موضوعات قصيرة ومركزة. تتضمن وحدة الموضوع القصيرة دراسة وممارسة مشتركة بحيث يؤدي الجمع بين الاثنين إلى تحسين الذاكرة والقدرة على الإجابة بشكل صحيح في الاختبار النظري. في كل مرة يتعين عليك دراسة وحدة دراسية قصيرة واحدة وفي نهاية الدراسة والممارسة ، خذ قسطًا من الراحة وانتعش بنفسك ، وتناول شيئًا خفيفًا ، واشرب شيئًا باردًا ومنعشًا - وانتقل إلى الموضوع التالي!</p>
        </li>
      </ul>
       <nav><h2>اللغة</h2></nav> 
      <nav>
        <NavLink to="AR">اللغة العربية </NavLink>
        <NavLink to="EN">English</NavLink>
        <NavLink to="HE">עברית</NavLink>
      </nav>
     
     

      <Outlet />
      

    </div>
  )
}
